
import { queryClient } from "../../../../../..";
import { __CheckAccessToProfileType } from "../../../../../../utils/accessControl";
import { SERVICE_USER_PROFILE_TYPES } from "../../../../../../CONSTANTS";

  //i.e  access CHECK 
  export const getViewableProfileTypeOptions = () => {
    const allTpls = queryClient.getQueryData('allTpls')
    const {user} = queryClient.getQueryData('userData') || {}
    return allTpls
    .filter((tpl) => !SERVICE_USER_PROFILE_TYPES.includes(tpl.kp_content_type))
    .filter(
      (tpl) =>
        __CheckAccessToProfileType(user, "READ", tpl.kp_content_type)
    )
    .map((tpl) => ({
      display: tpl.general?.content?.title || tpl.kp_content_type,
      value: tpl.kp_content_type,
      to: `/community-listing/${tpl.kp_content_type}`,
    }));
  }
  